// import check from "../../../images/detailproject/check.png";
import { ITask } from "@/api/tasks/types";
import { IUserWithAssignment, useAssignedUsers } from "@/features/projects/hooks/useAssignedUsers";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { TaskBoardCard } from "@features/projects/components/projectsPage/TaskBoardCard";

interface ITaskBoardProps {
  task: ITask,
  selectTask: (task: ITask) => void;
}

export const TaskBoard = ({ task, selectTask }: ITaskBoardProps) => {
  const { userAssigned } = useAssignedUsers({ taskId: task.id });

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: task.id,
    data: {
      type: 'task',
      sectionId: task.sectionId
    }
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  // Determinar estado para color
  let status: "pendiente" | "enprogreso" | "completado" = "pendiente";
  if (task.state === "En progreso" || task.state === "en progreso") status = "enprogreso";
  if (task.state === "Completado" || task.state === "completado") status = "completado";

  return (
    <div ref={setNodeRef} style={style} {...listeners} {...attributes}>
      <TaskBoardCard
        title={task.title}
        status={status}
        startDate={task.startDate}
        endDate={task.endDate}
        users={userAssigned.map((user: IUserWithAssignment) => ({
          id: String(user.userid),
          name: `${user.firstname ?? ''} ${user.firstlastname ?? ''}`.trim(),
          avatarUrl: undefined // o user.picture si existe
        }))}
        onClick={() => selectTask(task)}
      />
    </div>
  );
};
